import React from 'react';
import { Link, HStack } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

export const ExternalLink = ({
  href,
  children,
  ...props
}) => (
  <Link
    isExternal
    role="group"
    href={href}
    {...props}
  >
    <HStack>
      {children}
      <ExternalLinkIcon
        opacity={0.2}
        _groupHover={{ opacity: 1 }}
        data-testid={props['data-testid'] ? `${props['data-testid']}.Icon` : null}
      />
    </HStack>
  </Link>
);
